var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasDarkKitchen)?_c('sidebar-item',{attrs:{"link":{
    name: _vm.copy.moduleName,
    icon: 'ni ni-book-bookmark text-success',
    path: _vm.basePath
  }}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }